import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { AddCircle, DragIndicator, MoreHoriz, RemoveCircle } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import NotificationsIcon from '@mui/icons-material/Notifications';
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from 'moment';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_OFFERS,
} from '../../../../constants/RoleConsts';
import { handleOnDragEnd } from '../../../../shared/custom-dragdrop/dragDrop';
import TablePaginationActions from '../../../../shared/table-pagination/TablePaginationActions';
import { OFFER_EDIT, OFFER_NOTIFICATION_CREATE } from '../../../../constants/OfferConst';
import BulkActionCheckBox from '../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import { PARTIAL_CHECKBOX_GREEN } from '../../../../utils/formUtils';

const CmsOfferTable = (props) => {
  const {
    offerList,
    page,
    rowsPerPage,
    handleCellMenuClick,
    selectedValue,
    handleClose,
    onClickRowViewDetails,
    onViewDetails,
    onClickDeleteOffer,
    handleChangePage,
    handleChangeRowsPerPage,
    onOpenDrawer,
    onActiveDeActiveOffer,
    permissions,
    setVisible,
    setOfferList,
    searchText,
    handleSelectAll,
    isAllSelected,
    setIsAllSelected,
    handleCheckboxChange,
    selectedOfferListLength,
    cmsOffer,
    getOffersType,
    dragDisabled,
  } = props;

  const validateEndDate = (offer) => {
    if (offer && offer.isActive) return true;
    const toDay = moment(new Date(), 'DD-MM-YYYY');
    const endDate = moment(
      `${offer.duration.endDate} ${offer.duration.endTime}`,
      'DD-MM-YYYY HH:mm',
    );
    return !endDate.isSameOrBefore(toDay);
  };

  const isEditButtonShow = (offerKey) => {
    return offerKey?.duration?.alwaysActive ||
      moment().isSameOrBefore(moment(offerKey.duration.endDate, 'DD-MM-YYYY'), 'day')
      ? { display: 'block' }
      : { display: 'none' };
  };

  return (
    <TableContainer>
      <Table className='list-table' aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
              <BulkActionCheckBox
                onChange={handleSelectAll}
                checked={isAllSelected || false}
                selectedLength={selectedOfferListLength}
                totalLength={cmsOffer?.length}
                inputProps={{
                  'aria-label': 'select all offers',
                }}
                className={PARTIAL_CHECKBOX_GREEN}
              />
            </TableCell>
            <TableCell className='w-25'>Name</TableCell>
            <TableCell className='w-10'>Type</TableCell>
            <TableCell className='w-5'>No of Cards</TableCell>
            <TableCell className='w-25'>Schedule</TableCell>
            <TableCell className='w-15 text-center'>Status</TableCell>
            <TableCell align='right'></TableCell>
          </TableRow>
        </TableHead>

        <DragDropContext
          onDragEnd={(event) =>
            handleOnDragEnd(event, setVisible, offerList, setOfferList, false, page, rowsPerPage)
          }
          isDropDisabled={dragDisabled}
        >
          <Droppable droppableId='cms' isDropDisabled={dragDisabled}>
            {(provided) => (
              <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                {(rowsPerPage > 0
                  ? offerList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : offerList
                ).map((offerKey, key) => (
                  <Draggable
                    key={offerKey.id}
                    draggableId={offerKey.id}
                    index={key}
                    isDragDisabled={dragDisabled}
                  >
                    {(provided) => (
                      <TableRow
                        key={key}
                        className='border-white pointer'
                        onClick={(e) => {
                          onClickRowViewDetails(offerKey, e);
                        }}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <TableCell className='w-12'>
                          {!dragDisabled && (
                            <span style={{ marginRight: 1.5 }}>
                              <DragIndicator className='res-menu-accordion-drag' />
                            </span>
                          )}
                          <Checkbox
                            onChange={(event) => handleCheckboxChange(offerKey?.id)}
                            checked={offerKey?.isChecked || false}
                            inputProps={{
                              'aria-label': `select offers ${offerKey?.id}`,
                            }}
                          />
                        </TableCell>
                        <TableCell className='w-25'>{offerKey?.name}</TableCell>
                        <TableCell className='w-10'>{getOffersType(offerKey?.type)}</TableCell>
                        <TableCell className='w-15'>{offerKey?.noOfCards}</TableCell>
                        <TableCell className='w-25'>{offerKey?.displaySchedule}</TableCell>
                        <TableCell
                          className='w-15'
                          onClick={(e) => onClickRowViewDetails(offerKey, e, true)}
                        >
                          <div className='d-flex justify-content-center'>
                            <div
                              className={`${offerKey?.statusClass} pill d-flex justify-content-center align-items-center`}
                            >
                              <span className='ms-1'>{offerKey?.status}</span>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell align='right'>
                          {permissions[RBAC_TYPE_CMS_OFFERS] ===
                            RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                            <Button
                              aria-controls='simple-menu'
                              aria-haspopup='true'
                              onClick={(e) => {
                                handleCellMenuClick(e, offerKey);
                              }}
                              className='showpopupInner'
                            >
                              <MoreHoriz className='showpopupInner' />
                            </Button>
                          )}
                          <Menu
                            id={key}
                            anchorEl={selectedValue?.anchorEl}
                            disableRestoreFocus
                            MenuListProps={{ autoFocusItem: false }}
                            keepMounted
                            open={
                              Boolean(selectedValue.anchorEl) && selectedValue.id === offerKey.id
                            }
                            onClose={handleClose}
                            className='shadow'
                          >
                            {offerKey.status !== 'Completed' &&
                              (selectedValue?.offer?.isActive ? (
                                <MenuItem
                                  className='pe-4'
                                  onClick={(e) =>
                                    onActiveDeActiveOffer(
                                      e,
                                      selectedValue?.offer?.isActive ? 'deactivate' : 'activate',
                                    )
                                  }
                                >
                                  <RemoveCircle className='me-2 action-menu-icon' />
                                  Deactivate
                                </MenuItem>
                              ) : (
                                validateEndDate(offerKey) && (
                                  <MenuItem
                                    className='pe-4'
                                    onClick={(e) =>
                                      onActiveDeActiveOffer(
                                        e,
                                        selectedValue?.offer?.isActive ? 'deactivate' : 'activate',
                                      )
                                    }
                                  >
                                    <AddCircle className='me-2 action-menu-icon' />
                                    Activate
                                  </MenuItem>
                                )
                              ))}

                            {offerKey.status !== 'Completed' && (
                              <MenuItem
                                className='pe-4'
                                onClick={(e) => onOpenDrawer(e, OFFER_EDIT)}
                                style={isEditButtonShow(offerKey)}
                              >
                                <CreateIcon className='me-2 action-menu-icon' />
                                Edit
                              </MenuItem>
                            )}
                            <MenuItem className='pe-4' onClick={(e) => onViewDetails(offerKey, e)}>
                              <VisibilityIcon className='me-2 action-menu-icon' />
                              View
                            </MenuItem>
                            <MenuItem
                              className='pe-4'
                              onClick={(e) => onOpenDrawer(e, OFFER_NOTIFICATION_CREATE)}
                            >
                              <NotificationsIcon className='me-2 action-menu-icon' />
                              Push Notification
                            </MenuItem>
                            <MenuItem className='pe-4' onClick={(e) => onClickDeleteOffer(e)}>
                              <DeleteForeverIcon className='me-2 action-menu-icon' />
                              Delete
                            </MenuItem>
                          </Menu>
                        </TableCell>
                      </TableRow>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </TableBody>
            )}
          </Droppable>
        </DragDropContext>
        <TableFooter>
          <TableRow className='paginator'>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              count={offerList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default CmsOfferTable;
